import de from './de'
import en from './en'

export default {
  de,
  en
}



// WEBPACK FOOTER //
// ./src/i18n/messages.js